module.exports = __webpack_public_path__ + "static/microgrind_sloik@0,75x-33664ff70efe68b79a46e66fc8731f77.png";